{
  "page": {
    "title": "บันทึกการตรวจสอบ",
    "subtitle": "ตรวจสอบการเปลี่ยนแปลงสำคัญทั้งหมดในระบบ Atlas OMS กรองตามโมดูล ผู้ดำเนินการ และเวลา",
    "coverage_note": "ข้อมูลเริ่มบันทึกตั้งแต่วันที่ระบบบันทึกการตรวจสอบนี้เปิดใช้งาน — กิจกรรมก่อนหน้านั้นไม่ได้ถูกเก็บย้อนหลัง"
  },
  "error": {
    "title": "โหลดข้อมูลบันทึกการตรวจสอบไม่สำเร็จ",
    "body": "เกิดข้อผิดพลาดขณะโหลดบันทึกการตรวจสอบ กรุณาลองใหม่อีกครั้ง",
    "retry": "ลองใหม่"
  },
  "empty": {
    "title": "ไม่พบรายการบันทึกการตรวจสอบ",
    "body": "ลองขยายตัวกรองหรือช่วงวันที่ จะไม่มีข้อมูลก่อนวันที่ระบบบันทึกการตรวจสอบนี้เปิดใช้งาน เนื่องจากกิจกรรมก่อนหน้านั้นไม่ได้ถูกเก็บย้อนหลัง"
  },
  "column": {
    "time": "เวลา",
    "activity": "กิจกรรม",
    "module": "โมดูล",
    "target": "เป้าหมาย",
    "actor": "ผู้ดำเนินการ",
    "result": "ผลลัพธ์",
    "view_details": "ดูรายละเอียด",
    "time_utc_suffix": "({{utc}} UTC)"
  },
  "filters": {
    "search_placeholder": "ค้นหารหัสอ้างอิง เป้าหมาย หรือผู้ดำเนินการ…",
    "all_modules": "ทุกโมดูล",
    "all_results": "ทุกผลลัพธ์",
    "activity_placeholder": "กิจกรรม",
    "actor_placeholder": "อีเมลผู้ดำเนินการ",
    "clear": "ล้างตัวกรอง",
    "date_24h": "24 ชั่วโมงที่ผ่านมา",
    "date_7d": "7 วันที่ผ่านมา",
    "date_30d": "30 วันที่ผ่านมา",
    "date_custom": "กำหนดช่วงเอง",
    "date_from": "จาก",
    "date_to": "ถึง"
  },
  "module": {
    "inventory": "คลังสินค้า",
    "orders": "คำสั่งซื้อ",
    "promotions": "โปรโมชัน",
    "users": "ผู้ใช้งาน",
    "authentication": "การยืนยันตัวตน",
    "integrations": "การเชื่อมต่อระบบ",
    "audit": "การตรวจสอบ"
  },
  "result": {
    "success": "สำเร็จ",
    "partial": "สำเร็จบางส่วน",
    "failed": "ล้มเหลว"
  },
  "source": {
    "backoffice": "ระบบหลังบ้าน (Backoffice)",
    "csv": "ไฟล์ CSV",
    "sino_api": "Sino API",
    "scheduler": "ตัวจัดตารางเวลา",
    "system": "ระบบ"
  },
  "export": {
    "label_idle": "ส่งออก CSV",
    "label_starting": "กำลังเริ่มส่งออก…",
    "label_queued": "อยู่ในคิวส่งออก…",
    "label_running": "กำลังเตรียมไฟล์ส่งออก…",
    "label_done": "ส่งออก CSV",
    "label_failed": "ส่งออก CSV",
    "aria_idle": "ส่งออกรายการบันทึกการตรวจสอบที่กรองแล้วเป็น CSV",
    "aria_starting": "กำลังเริ่มส่งออก",
    "aria_queued": "การส่งออกอยู่ในคิว",
    "aria_running": "กำลังส่งออก",
    "aria_done": "ไฟล์ส่งออกพร้อมแล้ว — เริ่มส่งออกใหม่ได้",
    "aria_failed": "การส่งออกล้มเหลว — ลองใหม่อีกครั้ง",
    "download": "ดาวน์โหลด CSV ({{count}} แถว)",
    "disabled_invalid_range": "กรุณาระบุวันที่เริ่มต้นและสิ้นสุดก่อนส่งออก",
    "toast_start_failed": "เริ่มการส่งออกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
    "toast_poll_failed": "ตรวจสอบสถานะการส่งออกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
    "toast_failed": "การส่งออกล้มเหลว กรุณาลองใหม่อีกครั้ง",
    "toast_failed_reason": "การส่งออกล้มเหลว: {{reason}}",
    "toast_done": "ไฟล์ส่งออกพร้อมแล้ว — {{count}} แถว"
  },
  "drawer": {
    "title": "รายละเอียดเหตุการณ์",
    "error_body": "เกิดข้อผิดพลาดขณะโหลดเหตุการณ์นี้ กรุณาลองใหม่อีกครั้ง",
    "retry": "ลองใหม่",
    "field_time": "เวลา",
    "field_time_utc": "UTC: {{utc}}",
    "field_actor": "ผู้ดำเนินการ",
    "field_source": "แหล่งที่มา",
    "field_target": "เป้าหมาย",
    "field_result": "ผลลัพธ์",
    "field_correlation_id": "รหัสอ้างอิง",
    "copy_correlation": "คัดลอกรหัสอ้างอิง",
    "copy_correlation_success": "คัดลอกรหัสอ้างอิงแล้ว",
    "related_events": "เหตุการณ์ที่เกี่ยวข้อง",
    "changes_title": "การเปลี่ยนแปลง",
    "changes_field": "ฟิลด์",
    "changes_before": "ก่อน",
    "changes_after": "หลัง",
    "auth_title": "รายละเอียดการยืนยันตัวตน",
    "auth_attempted_email": "อีเมลที่พยายามเข้าสู่ระบบ",
    "auth_ip_address": "ที่อยู่ IP",
    "auth_user_agent": "User Agent",
    "import_title": "สรุปผลการนำเข้า",
    "import_succeeded": "สำเร็จ",
    "import_failed": "ล้มเหลว",
    "import_skipped": "ข้าม"
  }
}
